var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"subtitle has-text-centered"},[_vm._v("ArchiveStore helpers")]),_c('action-list',{attrs:{"actions":_vm.actions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }